import styled from '@emotion/styled/macro';

const ToolTipContent = styled.div`
    opacity: 0;
    min-width: 252px;
    white-space: normal;
    padding: 10px;
    position: absolute;
    top: -84px;
    color: white;
    background-color: #444340;
    align-items: center;
    left: -128px;
    height: 56px;
    justify-content: center;
    display: flex;
    span {
        border-color: #333 transparent transparent transparent;
        border-style: solid;
        border-width: 6px 6px 0 6px;
        height: 0;
        position: absolute;
        bottom: -6px;
        left: 
        width: 0;
      }
    `

const ToolTipWrap = styled.div`
    cursor: pointer;
    display: inline-flex;
    position: relative;
    verticalAlign: top;
    justifyContent: center;
    :hover {
    ${ToolTipContent} {
        opacity: 1;
        }
    }
`

interface Props {
    children: any;
    toolTipText: string;
}

const ToolTip = (props: Props) => {
    return (
        <ToolTipWrap >
            {props.children}
            <ToolTipContent>
                {props.toolTipText}
                <span />
            </ToolTipContent>
        </ToolTipWrap>
    );
};

export default ToolTip;